import { useState } from 'react';
import { CashierCurrencyType } from '@/graphql/schema';
import useCashierCurrencyChange from '@/server/components/NavBar/LoggedInControls/UserControls/UserBalance/Balance/useBalance/useCashierCurrencyChange';
import useCurrencyChangeListener from '@/server/components/NavBar/LoggedInControls/UserControls/UserBalance/Balance/useBalance/useCurrencyChangeListener';
import getUserBalance from '@/server/graphql/getUserBalance';

const useWalletCurrency = (
  initialCurrency?: CashierCurrency,
  cashierCurrencyType?: CashierCurrencyType,
) => {
  const [walletCurrency, setCurrency] = useState(initialCurrency);
  const [walletCurrencyType, setCurrencyType] = useState(cashierCurrencyType);

  const onChange = async () => {
    const { currency, config } = await getUserBalance();
    setCurrency(currency);
    setCurrencyType(config.type);
  };

  useCashierCurrencyChange({
    onChange,
  });

  useCurrencyChangeListener({ onChange });

  return { walletCurrency, walletCurrencyType };
};

export default useWalletCurrency;
